import { createSlice } from "@reduxjs/toolkit";
import { PostVideoProps } from "./postVideo";

const initialState: PostVideoProps.State = {
  video_id: "",
  uploadedVideo: {} as PostVideoProps.Video,
  isUploading: false,
};

const slice = createSlice({
  name: "postVideo",
  initialState,
  reducers: {
    setUploadedVideoDraft: (
      state,
      action: PostVideoProps.setUploadedVideoDraft
    ) => {
      state.video_id = action.payload;
    },
    setUploadedVideo: (state, action: PostVideoProps.setUploadedVideo) => {
      state.uploadedVideo = action.payload;
    },
    setIsUploading: (state, action: PostVideoProps.setIsUploading) => {
      state.isUploading = action.payload;
    },
    reset: () => initialState,
  },
});

export const postVideoActions = slice.actions;
export const postVideoReducer = slice.reducer;
